import { jsx as _jsx } from "react/jsx-runtime";
import { Paper } from "@mantine/core";
import { ChatInput } from "./ChatInput.js";
export const ChatInputWrapper = ({ inputWrapperRef, inputRef }) => {
    return (_jsx(Paper, { bg: "light-dark(white, black)", ref: inputWrapperRef, style: {
            position: "absolute",
            bottom: "2px",
            left: "2px",
            right: "2px",
        }, children: _jsx(ChatInput, { inputRef: inputRef }) }));
};
